import { formatDateUS } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { masker, mapToNumeric } from '../../helpers/formatters'
import { mapFiles } from './upload'
import { DEPENDENTS_AREA } from '../consts'

const mapName = (fullName) => {
  const [ name, ...last ] = fullName?.trim().split(' ') || [ '' ]

  return {
    name: name || '',
    lastName: last.join(' ') || ''
  }
}

export const mapDependent = (dependent = {}, params) => {
  const name = dependent.name || ''
  const lastName = dependent.lastName || ''

  return {
    id: dependent.id,
    name,
    lastName,
    fullName: `${name} ${lastName}`.trim(),
    foreigner: dependent.foreigner,
    familySalary: dependent.familySalary,
    ir: dependent.ir,
    cpf: masker('###.###.###-##', dependent.cpf),
    phone: masker('(##) #####-####', dependent.phone),
    email: dependent.email,
    description: dependent.description,
    motherName: dependent.motherName,
    birthDate: dependent.birthDate,
    genderId: dependent.gender?.id,
    educationTypeId: dependent.educationType?.id,
    relationshipId: dependent.dependentRelation?.id,
    files: mapFiles(dependent.documentFiles, params),
    hasWorkDisability: dependent.hasDisability
  }
}

export const mapDependentInput = ({ entityId, schema, data }) => {
  const { invalidFields = [] } = data || {}
  const isCpfInvalid = invalidFields.includes('cpf')
  const fullName = mapName(data.fullName)

  return {
    name: fullName.name,
    last_name: fullName.lastName,
    email: data.email,
    foreigner: data.foreigner,
    family_salary: data.familySalary,
    ir: data.ir,
    description: data.description,
    mother_name: data.motherName,
    gender_id: data.genderId,
    education_type_id: data.educationTypeId,
    dependent_relation_id: data.relationshipId,
    has_disability: data.hasWorkDisability,
    ...(!isCpfInvalid ? { cpf: mapToNumeric(data.cpf) } : {}),
    ...(data?.birthDate ? { birth_date: formatDateUS(data.birthDate) } : {}),
    ...(data?.phone ? { phone: mapToNumeric(data.phone) } : {}),
    custom_fields: mapCustomFieldValues({
      data,
      schema,
      entityId,
      sectionId: DEPENDENTS_AREA.DEPENDENTS,
    })
  }
}
